import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=fb4f3488&"
import script from "./LoginForm.vue?vue&type=script&lang=js&"
export * from "./LoginForm.vue?vue&type=script&lang=js&"
import style0 from "./LoginForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormInput, BFormInvalidFeedback, BInputGroup, BAlert, BSpinner, BForm} from 'bootstrap-vue'
    installComponents(component, {BFormInput, BFormInvalidFeedback, BInputGroup, BAlert, BSpinner, BForm})
    

export default component.exports